import { ref } from "vue";
import { defineStore } from "pinia";

export const useTempStore = defineStore('temp', {
  // arrow function recommended for full type inference
  state: () => {
    return {
      // all these properties will have their type inferred automatically
      activeclub: '',
      activeevent: '',
      activemember: ''
    }
  },
})
